import {TranslationFunction} from "../../../i18n/i18n";
import {SubmissionDeliveryChannel} from "../../../client/submission/SubmissionApiClient";
import {SubmissionTranslKey} from "../SubmissionTranslKey";

export class SubmissionDeliveryChannelFormatter {
    static formatSubmissionDeliveryChannel(channel: SubmissionDeliveryChannel | undefined, t: TranslationFunction): string {
        if (channel === SubmissionDeliveryChannel.EMAIL) {
            return t(SubmissionTranslKey.DELIVERY_CHANNEL_EMAIL);
        }
        if (channel === SubmissionDeliveryChannel.ISDS) {
            return t(SubmissionTranslKey.DELIVERY_CHANNEL_ISDS);
        }
        return "";
    }
}
